export default "__VITE_ASSET__39ce06c6__"